/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VehicleCorporateCodeOutcome } from './VehicleCorporateCodeOutcome';
import {
    VehicleCorporateCodeOutcomeFromJSON,
    VehicleCorporateCodeOutcomeFromJSONTyped,
    VehicleCorporateCodeOutcomeToJSON,
    VehicleCorporateCodeOutcomeToJSONTyped,
} from './VehicleCorporateCodeOutcome';
import type { VehicleSummary } from './VehicleSummary';
import {
    VehicleSummaryFromJSON,
    VehicleSummaryFromJSONTyped,
    VehicleSummaryToJSON,
    VehicleSummaryToJSONTyped,
} from './VehicleSummary';

/**
 * Terminal event when all batches have arrived. Carries the canonical
 * vehicle list (deduped across batches, scored, tags applied) so the SSE
 * client ends up with the same view as a polling client. Mirrors
 * `SearchStreamComplete`.
 * 
 * @export
 * @interface VehicleStreamComplete
 */
export interface VehicleStreamComplete {
    /**
     * 
     * @type {string}
     * @memberof VehicleStreamComplete
     */
    type: VehicleStreamCompleteTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof VehicleStreamComplete
     */
    totalItems: number;
    /**
     * Aggregated + scored vehicle list. Equivalent to the polling
     * endpoint's final response.
     * 
     * @type {Array<VehicleSummary>}
     * @memberof VehicleStreamComplete
     */
    items?: Array<VehicleSummary>;
    /**
     * 
     * @type {string}
     * @memberof VehicleStreamComplete
     */
    pickupLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleStreamComplete
     */
    dropoffLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleStreamComplete
     */
    pickupDatetime?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleStreamComplete
     */
    dropoffDatetime?: string;
    /**
     * True when the user supplied a discount/promo code that the vendor rejected; the items shown are standard cash rates. Mirrors the polling response field (GON-6109).
     * @type {boolean}
     * @memberof VehicleStreamComplete
     */
    discountCodeNotAccepted?: boolean;
    /**
     * 
     * @type {Array<VehicleCorporateCodeOutcome>}
     * @memberof VehicleStreamComplete
     */
    corporateCodeOutcomes?: Array<VehicleCorporateCodeOutcome>;
}


/**
 * @export
 */
export const VehicleStreamCompleteTypeEnum = {
    Complete: 'complete'
} as const;
export type VehicleStreamCompleteTypeEnum = typeof VehicleStreamCompleteTypeEnum[keyof typeof VehicleStreamCompleteTypeEnum];


/**
 * Check if a given object implements the VehicleStreamComplete interface.
 */
export function instanceOfVehicleStreamComplete(value: object): value is VehicleStreamComplete {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('totalItems' in value) || value['totalItems'] === undefined) return false;
    return true;
}

export function VehicleStreamCompleteFromJSON(json: any): VehicleStreamComplete {
    return VehicleStreamCompleteFromJSONTyped(json, false);
}

export function VehicleStreamCompleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleStreamComplete {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'totalItems': json['total_items'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(VehicleSummaryFromJSON)),
        'pickupLocation': json['pickup_location'] == null ? undefined : json['pickup_location'],
        'dropoffLocation': json['dropoff_location'] == null ? undefined : json['dropoff_location'],
        'pickupDatetime': json['pickup_datetime'] == null ? undefined : json['pickup_datetime'],
        'dropoffDatetime': json['dropoff_datetime'] == null ? undefined : json['dropoff_datetime'],
        'discountCodeNotAccepted': json['discount_code_not_accepted'] == null ? undefined : json['discount_code_not_accepted'],
        'corporateCodeOutcomes': json['corporate_code_outcomes'] == null ? undefined : ((json['corporate_code_outcomes'] as Array<any>).map(VehicleCorporateCodeOutcomeFromJSON)),
    };
}

export function VehicleStreamCompleteToJSON(json: any): VehicleStreamComplete {
    return VehicleStreamCompleteToJSONTyped(json, false);
}

export function VehicleStreamCompleteToJSONTyped(value?: VehicleStreamComplete | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'total_items': value['totalItems'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(VehicleSummaryToJSON)),
        'pickup_location': value['pickupLocation'],
        'dropoff_location': value['dropoffLocation'],
        'pickup_datetime': value['pickupDatetime'],
        'dropoff_datetime': value['dropoffDatetime'],
        'discount_code_not_accepted': value['discountCodeNotAccepted'],
        'corporate_code_outcomes': value['corporateCodeOutcomes'] == null ? undefined : ((value['corporateCodeOutcomes'] as Array<any>).map(VehicleCorporateCodeOutcomeToJSON)),
    };
}

